export const menu = {
    signOut: 'Sign out',
    adminPanel: 'Admin panel',
};
